(function() {
  const drawer = document.querySelector('cart-drawer.kc-cart');
  if (!drawer) return;

  const itemsEl = drawer.querySelector('#KC-CartItems');
  const subtotalEl = drawer.querySelector('[data-kc-subtotal]');
  const progressEl = drawer.querySelector('#KC-CartProgress');
  const progressText = drawer.querySelector('[data-kc-progress-text]');
  const progressBar = drawer.querySelector('[data-kc-progress-bar]');
  const saveMoreEl = drawer.querySelector('#KC-SaveMore');
  const saveMoreGrid = drawer.querySelector('[data-kc-save-more-grid]');
  const checkoutUpsellBtn = drawer.querySelector('[data-kc-checkout-upsell]');
  const discountsRow = drawer.querySelector('[data-kc-discounts-row]');
  const discountsAmt = drawer.querySelector('[data-kc-discounts-amount]');
  const catalogScript = drawer.querySelector('[data-kc-upsell-catalog]');
  let CATALOG = { hats: [], protections: [] };
  if (catalogScript) {
    try { CATALOG = JSON.parse(catalogScript.textContent); } catch (e) { CATALOG = { hats: [], protections: [] }; }
  }

  const i18nScript = drawer.querySelector('[data-kc-i18n]');
  let I18N = {};
  if (i18nScript) { try { I18N = JSON.parse(i18nScript.textContent); } catch (e) { I18N = {}; } }
  const SHIP_CENTS = I18N.shipCents || 499;
  const PATTERNS = I18N.patterns || {};
  const saveMoreSub = drawer.querySelector('[data-kc-savemore-sub]');

  const hatIds = new Set(CATALOG.hats.map(function (v) { return v.id; }));
  const protIds = new Set(CATALOG.protections.map(function (v) { return v.id; }));

  function catalogById(variantId) {
    var all = CATALOG.hats.concat(CATALOG.protections);
    for (var i = 0; i < all.length; i += 1) {
      if (all[i].id === variantId) return all[i];
    }
    return null;
  }

  function localizedPattern(t) { return (t && PATTERNS[t]) ? PATTERNS[t] : t; }
  function localizedProductName(item) {
    if (protIds.has(item.variant_id)) return I18N.nameProtection || item.product_title;
    if (hatIds.has(item.variant_id)) return I18N.nameHat || item.product_title;
    return item.product_title;
  }

  const FREE_SHIP_CENTS = progressEl ? parseInt(progressEl.dataset.freeShipCents, 10) : 7499;
  const UNLOCK_TPL = progressEl ? progressEl.dataset.unlockTemplate : '{amount} away from free shipping';
  const UNLOCKED_TEXT = progressEl ? progressEl.dataset.unlockedText : 'Free shipping unlocked';
  const LOCALE = document.documentElement.lang || 'en';
  const MONEY_FORMATTER = new Intl.NumberFormat(LOCALE.indexOf('fr') === 0 ? 'fr-CA' : 'en-CA', {
    style: 'currency',
    currency: 'CAD'
  });

  function money(cents) {
    return MONEY_FORMATTER.format((cents || 0) / 100);
  }

  // Real free-shipping progress: fills with the subtotal toward the 74,99 $ threshold.
  function updateProgress(sav) {
    if (!progressEl) return;
    const reached = sav.freeShipping;
    const pct = Math.max(0, Math.min(100, Math.round(sav.subtotal * 100 / FREE_SHIP_CENTS)));
    progressEl.classList.toggle('is-unlocked', reached);
    if (progressBar) {
      const color = reached ? '#34c759' : '#ffd21e';
      progressBar.style.background = 'linear-gradient(to right, ' + color + ' ' + pct + '%, #e7dfce ' + pct + '%)';
      progressBar.style.transition = 'background .6s ease';
      progressBar.classList.toggle('kc-cart__progress-bar--pulse', !reached && pct > 0);
    }
    if (progressText) progressText.textContent = progressMessage(sav);
  }

  function renderItems(cart) {
    if (!itemsEl) return;
    itemsEl.innerHTML = '';
    const tPattern = itemsEl.dataset.tPattern;
    const tSize = itemsEl.dataset.tSize;
    const tSizeVal = itemsEl.dataset.tSizeValue;
    const tMinus = itemsEl.dataset.tQtyMinus;
    const tPlus = itemsEl.dataset.tQtyPlus;
    const tRemove = itemsEl.dataset.tRemove;
    const sav = computeSavings(cart);

    cart.items.forEach(function(item, idx) {
      const realDiscount = item.original_line_price > item.final_line_price;
      const realPct = realDiscount
        ? Math.round((item.original_line_price - item.final_line_price) * 100 / item.original_line_price)
        : 0;
      // Hats really sell below their compare-at price (29,99 $ → 19,99 $): show the
      // crossed-out reference price and the fixed "$10 off" label. No helmet discounts.
      const cat = catalogById(item.variant_id);
      const hatDeal = !realDiscount && hatIds.has(item.variant_id) && cat && cat.compare_at_price > cat.price;
      const dealLabel = realDiscount ? ('−' + realPct + '% off') : (hatDeal ? (I18N.hatDeal || '') : '');
      const compareLine = realDiscount
        ? item.original_line_price
        : (hatDeal ? cat.compare_at_price * item.quantity : 0);
      const line = document.createElement('div');
      line.className = 'kc-cart__line';
      line.setAttribute('data-line-key', item.key);
      line.innerHTML = [
        '<img class="kc-cart__line-image" src="' + (item.image ? item.image.replace(/_(?:small|grande|medium|large)\./, '_144x.') : '') + '" alt="" loading="lazy">',
        '<div class="kc-cart__line-body">',
          '<h3 class="kc-cart__line-title">' + escapeHtml(localizedProductName(item)) + '</h3>',
          (I18N.starsLine ? '<div class="kc-cart__line-stars" aria-hidden="true">' + escapeHtml(I18N.starsLine) + '</div>' : ''),
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="kc-cart__line-variant">' + tPattern + ': ' + escapeHtml(localizedPattern(item.variant_title)) + '</div>' : ''),
          '<div class="kc-cart__line-variant">' + tSize + ': ' + tSizeVal + '</div>',
          (dealLabel ? '<div class="kc-cart__line-discount-label">' + escapeHtml(dealLabel) + '</div>' : ''),
          '<div class="kc-cart__line-qty">',
            '<button type="button" data-kc-qty-minus aria-label="' + tMinus + '">−</button>',
            '<span class="kc-cart__line-qty-val" data-kc-qty-val>' + item.quantity + '</span>',
            '<button type="button" data-kc-qty-plus aria-label="' + tPlus + '">+</button>',
          '</div>',
        '</div>',
        '<div class="kc-cart__line-side">',
          '<div class="kc-cart__line-prices">',
            '<span class="kc-cart__line-price">' + money(item.final_line_price) + '</span>',
            (compareLine ? '<span class="kc-cart__line-compare">' + money(compareLine) + '</span>' : ''),
          '</div>',
          '<button type="button" class="kc-cart__line-remove" data-kc-remove aria-label="' + tRemove + '" title="' + tRemove + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg></button>',
        '</div>'
      ].join('');
      itemsEl.appendChild(line);
    });
  }

  function classifyCart(cart) {
    let hats = 0, protections = 0, protSubtotal = 0;
    cart.items.forEach(function (item) {
      if (hatIds.has(item.variant_id)) {
        hats += item.quantity;
      } else if (protIds.has(item.variant_id)) {
        protections += item.quantity;
        protSubtotal += item.final_line_price;
      }
    });
    return { hats: hats, protections: protections, protSubtotal: protSubtotal, n: hats + protections };
  }

  // Real savings only — no invented discounts:
  //  - hats sell below their compare-at price (29,99 $ → 19,99 $): count that difference
  //  - free shipping (4,99 $ value) once the subtotal reaches the threshold (74,99 $)
  //  - helmets are never discounted
  function computeSavings(cart) {
    const st = classifyCart(cart);
    const subtotal = cart.total_price;
    let hatDiscount = 0;
    cart.items.forEach(function (item) {
      const cat = catalogById(item.variant_id);
      if (cat && hatIds.has(item.variant_id) && cat.compare_at_price > cat.price) {
        hatDiscount += (cat.compare_at_price - cat.price) * item.quantity;
      }
    });
    const freeShipping = subtotal >= FREE_SHIP_CENTS;
    const shippingSaving = freeShipping ? SHIP_CENTS : 0;
    return {
      st: st,
      subtotal: subtotal,
      freeShipping: freeShipping,
      shippingSaving: shippingSaving,
      totalSavings: hatDiscount + shippingSaving,
      hatDiscount: hatDiscount
    };
  }

  // The single next reward to chase (only real ones: the hat deal or free shipping).
  function nextRewardText(sav) {
    const st = sav.st;
    if (st.protections >= 1 && st.hats < 4) return I18N.prog5 || '';
    if (st.protections === 0 && st.n >= 1) return I18N.progHelmet || '';
    return '';
  }

  // Progress line: distance to free shipping, then celebrate it —
  // and when a hat is in the cart, celebrate its 10 $ deal too.
  function progressMessage(sav) {
    if (sav.freeShipping) {
      if (sav.hatDiscount > 0 && I18N.progFreeDoneHat) return I18N.progFreeDoneHat;
      return I18N.progFreeDone || UNLOCKED_TEXT || '';
    }
    const remaining = FREE_SHIP_CENTS - sav.subtotal;
    const tpl = I18N.progFree || UNLOCK_TPL || '{amount}';
    return tpl.replace('{amount}', money(remaining));
  }

  function showSaveMore(visible) {
    if (saveMoreEl) saveMoreEl.style.display = visible ? '' : 'none';
  }

  function renderSaveMore(cart) {
    if (!saveMoreEl || !saveMoreGrid) return;
    saveMoreGrid.innerHTML = '';
    if (!cart.items || cart.items.length === 0) { showSaveMore(false); return; }

    const sav = computeSavings(cart);
    const state = sav.st;
    const G = saveMoreEl.dataset;
    // No early "best deal" exit: gainFor() decides per card — if nothing is
    // left to pitch, cards stays empty and the strip hides below.

    // Read by attribute (NOT dataset): names contain digits (5/10) which break the
    // dataset camelCase mapping, so dataset.tGain5Off would be undefined.
    const attr = function (name) { return saveMoreEl.getAttribute(name) || ''; };
    const tGainFreeShip = attr('data-t-gain-free-ship');
    const tGain5Off = attr('data-t-gain-5-off');      // free delivery + 5%
    const tGain5Only = attr('data-t-gain-5-only');    // 5% only
    const tGain10Off = attr('data-t-gain-10-off');    // free delivery + 10%
    const tGain10Only = attr('data-t-gain-10-only');  // 10% only

    // What to propose (honest version):
    //  - hats: always worth pitching (real 10 $ deal), capped at 4 in the cart
    //  - helmets: ONLY when the cart has no helmet yet — never push a 2nd helmet
    function gainFor(variant, isProtection) {
      if (!isProtection) {
        if (state.hats >= 4) return '';
        return state.protections >= 1 ? tGainFreeShip : tGain10Only;
      }
      if (state.protections === 0) return tGain5Only;
      return '';
    }

    const cards = [];
    CATALOG.hats.slice(0, 4).forEach(function (v) {
      const g = gainFor(v, false);
      if (g) cards.push({ type: 'hat', variant: v, gain: g });
    });
    // Helmet cards only appear when there is no helmet in the cart yet.
    CATALOG.protections.slice(0, 4).forEach(function (v) {
      const g = gainFor(v, true);
      if (g) cards.push({ type: 'protection', variant: v, gain: g });
    });

    if (!cards.length) { showSaveMore(false); return; }
    showSaveMore(true);
    if (saveMoreSub) saveMoreSub.textContent = '';

    cards.forEach(function(card) {
      const tag = card.type === 'protection' ? (G.tTagProtection || '') : (G.tTagHat || '');
      const el = document.createElement('div');
      el.className = 'kc-cart__save-more-card';
      // The whole card is the action — no "+" button, the benefit is the call to action.
      el.setAttribute('data-kc-save-more-add', '');
      el.setAttribute('data-variant-id', card.variant.id);
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      // Real deal only: a hat whose compare-at price is above its selling price
      // shows 29,99 $ crossed out → 19,99 $ with a fixed "−10 $" badge.
      var isHatDeal = card.type === 'hat' && card.variant.compare_at_price > card.variant.price;
      var saveDollars = isHatDeal ? Math.round((card.variant.compare_at_price - card.variant.price) / 100) : 0;
      var saveBadge = isHatDeal
        ? ((document.documentElement.lang || '').indexOf('fr') === 0 ? ('−' + saveDollars + ' $') : ('−$' + saveDollars))
        : '';
      var roleName = card.type === 'hat'
        ? ((G.tTagHat || 'Chapeau assorti') + ' · ' + localizedPattern(card.variant.title))
        : ((I18N.tagProtection || 'Casque') + ' · ' + localizedPattern(card.variant.title));
      el.className += ' kc-cart__save-more-card--pulse';
      el.innerHTML = [
        '<div class="kc-cart__save-more-card-media">',
          '<img class="kc-cart__save-more-card-image" src="' + escapeHtml(card.variant.image || '') + '" alt="" loading="lazy">',
          (saveBadge ? '<span class="kc-cart__save-more-card-badge">' + escapeHtml(saveBadge) + '</span>' : ''),
        '</div>',
        '<div class="kc-cart__save-more-card-name">' + escapeHtml(roleName) + '</div>',
        '<div class="kc-cart__save-more-card-price">' + (
          isHatDeal
            ? '<s style="opacity:.55">' + money(card.variant.compare_at_price) + '</s> <strong>' + money(card.variant.price) + '</strong>'
            : money(card.variant.price)
        ) + '</div>'
      ].join('');
      saveMoreGrid.appendChild(el);
    });
  }

  function showCheckoutUpsell(visible) {
    if (checkoutUpsellBtn) checkoutUpsellBtn.style.display = visible ? 'block' : 'none';
  }

  function updateCheckoutUpsell(cart) {
    if (!checkoutUpsellBtn) return;
    // Replaced by the static trust/reviews line under the checkout button.
    checkoutUpsellBtn.style.display = 'none';
    if (true) return;
    const sav = computeSavings(cart);
    // Hide when empty or already at the best deal (10% off + free shipping).
    if (sav.st.n === 0 || (sav.freeShipping && sav.pct >= 10)) { showCheckoutUpsell(false); return; }
    showCheckoutUpsell(true);
    checkoutUpsellBtn.textContent = nextRewardText(sav);
  }

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  // Render straight from a cart object (no extra network call).
  function renderCart(cart) {
    if (!cart || cart.status) return; // cart.status set means an error payload
    const sav = computeSavings(cart);
    renderItems(cart);
    renderSaveMore(cart);
    updateCheckoutUpsell(cart);
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    // Shipping row: FREE once the threshold is reached, otherwise the real 4,99 $ rate.
    var shipAmountEl = drawer.querySelector('[data-kc-shipping-amount]');
    if (shipAmountEl) {
      shipAmountEl.textContent = sav.freeShipping
        ? (shipAmountEl.getAttribute('data-t-free') || '')
        : money(SHIP_CENTS);
    }
    if (discountsRow) {
      if (sav.totalSavings > 0) {
        discountsRow.style.display = 'flex';
        if (discountsAmt) discountsAmt.textContent = '−' + money(sav.totalSavings);
      } else {
        discountsRow.style.display = 'none';
        if (discountsAmt) discountsAmt.textContent = '';
      }
    }
    updateProgress(sav);
    drawer.classList.toggle('is-empty', cart.item_count === 0);

    // Keep the header cart bubble in sync, so removing an item updates the count badge.
    var cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) {
      var countEl = cartLink.querySelector('.kdc-header__cart-count');
      if (cart.item_count > 0) {
        var t = cart.item_count < 100 ? String(cart.item_count) : '99+';
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'kdc-header__cart-count';
          cartLink.appendChild(countEl);
        }
        countEl.textContent = t;
      } else if (countEl) {
        countEl.remove();
      }
    }
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(renderCart)
      .catch(function() { /* swallow */ });
  }

  function addVariantToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity || 1 }] }),
      credentials: 'same-origin'
    }).then(refresh);
  }

  function changeQty(key, qty) {
    // change.js already returns the full updated cart → render from it (no second fetch).
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
      credentials: 'same-origin'
    }).then(function(r) { return r.json(); }).then(renderCart).catch(function(){});
  }

  drawer.addEventListener('click', function(e) {
    const line = e.target.closest('.kc-cart__line');
    if (!line) return;
    const key = line.getAttribute('data-line-key');
    const qtyVal = line.querySelector('[data-kc-qty-val]');
    if (e.target.closest('[data-kc-qty-plus]')) {
      const next = parseInt(qtyVal.textContent, 10) + 1;
      if (qtyVal) qtyVal.textContent = next;        // optimistic → feels instant
      changeQty(key, next);
    } else if (e.target.closest('[data-kc-qty-minus]')) {
      const next = Math.max(0, parseInt(qtyVal.textContent, 10) - 1);
      if (qtyVal && next > 0) qtyVal.textContent = next; // optimistic (0 = removal, let re-render handle)
      changeQty(key, next);
    } else if (e.target.closest('[data-kc-remove]')) {
      changeQty(key, 0);
    }
  });

  // "Buy more save more" cards — the whole card adds the item (no + button)
  function addFromCard(card) {
    const id = card.getAttribute('data-variant-id');
    if (!id || card.classList.contains('is-adding')) return;
    card.classList.add('is-adding');
    addVariantToCart(id).finally(function() { card.classList.remove('is-adding'); });
  }
  if (saveMoreGrid) {
    saveMoreGrid.addEventListener('click', function(e) {
      const card = e.target.closest('[data-kc-save-more-add]');
      if (card) addFromCard(card);
    });
    saveMoreGrid.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const card = e.target.closest('[data-kc-save-more-add]');
      if (card) { e.preventDefault(); addFromCard(card); }
    });
  }

  // Contextual upsell button under checkout
  if (checkoutUpsellBtn) {
    checkoutUpsellBtn.addEventListener('click', function() {
      // Don't auto-add a default pattern — reveal the upsell cards so the shopper
      // chooses which pattern (hat) themselves.
      if (saveMoreEl) {
        saveMoreEl.style.display = '';
        saveMoreEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        saveMoreEl.classList.remove('is-flash');
        void saveMoreEl.offsetWidth; // restart animation
        saveMoreEl.classList.add('is-flash');
        setTimeout(function() { saveMoreEl.classList.remove('is-flash'); }, 1300);
      }
    });
  }

  // Populate everything from the live cart on load (items, savings, progress, upsell).
  refresh();

  // Listen for external cart updates (existing cart.js publishes via subscribe(), but we also poll on open)
  document.addEventListener('cart:updated', refresh);

  // Refresh whenever drawer is opened (in case cart changed elsewhere)
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class' && drawer.classList.contains('active')) {
          refresh();
        }
      });
    }).observe(drawer, { attributes: true });

  }
})();
